import script from "./LuceChat.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceChat.vue?vue&type=script&setup=true&lang=js"

import "./LuceChat.vue?vue&type=style&index=0&id=6fa6dd43&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa6dd43"]])

export default __exports__